function CircleInvalidIcon({
    height = 18, 
    width = 18, 
    className = '',
    onClick,
    color = '#FE543D'
}) {
    return (
        <svg 
            width={width} 
            height={height} 
            viewBox="0 0 18 18" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            onClick={onClick}
        >
            <path 
                fill={color}
                d="M5.33366 9.68758H12.667C12.8618 9.68758 13.025 9.62166 13.1567 9.48981C13.2886 9.35796 13.3545 9.19464 13.3545 8.99985C13.3545 8.80491 13.2886 8.64166 13.1567 8.51012C13.025 8.37843 12.8618 8.31258 12.667 8.31258H5.33366C5.13887 8.31258 4.97562 8.3785 4.84393 8.51035C4.71208 8.6422 4.64616 8.80552 4.64616 9.00031C4.64616 9.19525 4.71208 9.3585 4.84393 9.49004C4.97562 9.62173 5.13887 9.68758 5.33366 9.68758ZM9.00193 17.7084C7.79743 17.7084 6.66527 17.4799 5.60545 17.0227C4.54563 16.5656 3.62377 15.9453 2.83987 15.1617C2.05596 14.3781 1.4353 13.4566 0.977888 12.3972C0.520624 11.3379 0.291992 10.206 0.291992 9.00169C0.291992 7.79719 0.520548 6.66503 0.977659 5.60521C1.43477 4.54539 2.05512 3.62353 2.83872 2.83962C3.62232 2.05572 4.5438 1.43506 5.60316 0.977644C6.66252 0.52038 7.79437 0.291748 8.99872 0.291748C10.2032 0.291748 11.3354 0.520303 12.3952 0.977414C13.455 1.43453 14.3769 2.05488 15.1608 2.83848C15.9447 3.62207 16.5653 4.54355 17.0228 5.60291C17.48 6.66228 17.7087 7.79413 17.7087 8.99848C17.7087 10.203 17.4801 11.3351 17.023 12.395C16.5659 13.4548 15.9455 14.3766 15.1619 15.1605C14.3783 15.9444 13.4569 16.5651 12.3975 17.0225C11.3381 17.4798 10.2063 17.7084 9.00193 17.7084ZM9.00033 16.3334C11.0475 16.3334 12.7816 15.623 14.2024 14.2022C15.6232 12.7813 16.3337 11.0473 16.3337 9.00008C16.3337 6.95286 15.6232 5.21883 14.2024 3.798C12.7816 2.37716 11.0475 1.66675 9.00033 1.66675C6.9531 1.66675 5.21908 2.37716 3.79824 3.798C2.37741 5.21883 1.66699 6.95286 1.66699 9.00008C1.66699 11.0473 2.37741 12.7813 3.79824 14.2022C5.21908 15.623 6.9531 16.3334 9.00033 16.3334Z" 
            />
        </svg>
    )
}

export default CircleInvalidIcon;